import HowItWorksView from './HowItWorksView';

export default HowItWorksView;
